/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelPositionsParams,
  ModelPosition,
  ModelPositionInput,
  ModelPositions,
  RegenerateModelPositionsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new Model Position
 */
export const createModelPosition = (
    modelPositionInput: MaybeRefOrGetter<ModelPositionInput>,
 signal?: AbortSignal
) => {
      modelPositionInput = toValue(modelPositionInput);

      return axiosClient<ModelPosition>(
      {url: `/model-positions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelPositionInput, signal
    },
      );
    }




export const getCreateModelPositionMutationKey = () => ['createModelPosition'] as const;

export const getCreateModelPositionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelPosition>>, TError,CreateModelPositionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelPosition>>, TError,CreateModelPositionMutationVariables, TContext> => {

const mutationKey = getCreateModelPositionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelPosition>>, CreateModelPositionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModelPosition(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelPositionMutationResult = NonNullable<Awaited<ReturnType<typeof createModelPosition>>>
    export type CreateModelPositionMutationBody = ModelPositionInput
    export type CreateModelPositionMutationError = ErrorType<ValidationError | StandardError>
    export type CreateModelPositionMutationVariables = {data: ModelPositionInput}

    /**
 * @summary Create new Model Position
 */
export const useCreateModelPosition = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelPosition>>, TError,CreateModelPositionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelPosition>>,
        TError,
        CreateModelPositionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelPositionMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Positions list
 */
export const listModelPositions = (
    params?: MaybeRefOrGetter<ListModelPositionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelPositions>(
      {url: `/model-positions`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelPositionsQueryKey = (params?: MaybeRefOrGetter<ListModelPositionsParams>,) => {
    return [
    'model-positions', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelPositionsQueryOptions = <TData = Awaited<ReturnType<typeof listModelPositions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelPositionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelPositions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelPositionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelPositions>>> = ({ signal }) => listModelPositions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelPositions>>, TError, TData>
}

export type ListModelPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof listModelPositions>>>
export type ListModelPositionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Positions list
 */

export function useListModelPositions<TData = Awaited<ReturnType<typeof listModelPositions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelPositionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelPositions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelPositionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Regenerate Model Positions
 */
export const regenerateModelPositions = (
    params: MaybeRefOrGetter<RegenerateModelPositionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelPositions>(
      {url: `/model-positions/regenerate`, method: 'PUT',
        params, signal
    },
      );
    }




export const getRegenerateModelPositionsMutationKey = () => ['regenerateModelPositions'] as const;

export const getRegenerateModelPositionsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateModelPositions>>, TError,RegenerateModelPositionsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateModelPositions>>, TError,RegenerateModelPositionsMutationVariables, TContext> => {

const mutationKey = getRegenerateModelPositionsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateModelPositions>>, RegenerateModelPositionsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  regenerateModelPositions(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateModelPositionsMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateModelPositions>>>

    export type RegenerateModelPositionsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type RegenerateModelPositionsMutationVariables = {params: RegenerateModelPositionsParams}

    /**
 * @summary Regenerate Model Positions
 */
export const useRegenerateModelPositions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateModelPositions>>, TError,RegenerateModelPositionsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof regenerateModelPositions>>,
        TError,
        RegenerateModelPositionsMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateModelPositionsMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Position destroy
 */
export const destroyModelPosition = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-positions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelPositionMutationKey = () => ['destroyModelPosition'] as const;

export const getDestroyModelPositionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelPosition>>, TError,DestroyModelPositionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelPosition>>, TError,DestroyModelPositionMutationVariables, TContext> => {

const mutationKey = getDestroyModelPositionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelPosition>>, DestroyModelPositionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModelPosition(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelPositionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelPosition>>>

    export type DestroyModelPositionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelPositionMutationVariables = {id: string}

    /**
 * @summary Model Position destroy
 */
export const useDestroyModelPosition = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelPosition>>, TError,DestroyModelPositionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelPosition>>,
        TError,
        DestroyModelPositionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelPositionMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Model Position
 */
export const modelPosition = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelPosition>(
      {url: `/model-positions/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelPositionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-positions',id
    ] as const;
    }


export const getModelPositionQueryOptions = <TData = Awaited<ReturnType<typeof modelPosition>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPosition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelPositionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelPosition>>> = ({ signal }) => modelPosition(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelPosition>>, TError, TData>
}

export type ModelPositionQueryResult = NonNullable<Awaited<ReturnType<typeof modelPosition>>>
export type ModelPositionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Model Position
 */

export function useModelPosition<TData = Awaited<ReturnType<typeof modelPosition>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPosition>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelPositionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Position
 */
export const updateModelPosition = (
    id: MaybeRefOrGetter<string>,
    modelPositionInput: MaybeRefOrGetter<ModelPositionInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelPositionInput = toValue(modelPositionInput);

      return axiosClient<ModelPosition>(
      {url: `/model-positions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelPositionInput, signal
    },
      );
    }




export const getUpdateModelPositionMutationKey = () => ['updateModelPosition'] as const;

export const getUpdateModelPositionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelPosition>>, TError,UpdateModelPositionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelPosition>>, TError,UpdateModelPositionMutationVariables, TContext> => {

const mutationKey = getUpdateModelPositionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelPosition>>, UpdateModelPositionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelPosition(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelPositionMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelPosition>>>
    export type UpdateModelPositionMutationBody = ModelPositionInput
    export type UpdateModelPositionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelPositionMutationVariables = {id: string;data: ModelPositionInput}

    /**
 * @summary Update Model Position
 */
export const useUpdateModelPosition = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelPosition>>, TError,UpdateModelPositionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelPosition>>,
        TError,
        UpdateModelPositionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelPositionMutationOptions(options), queryClient);
    }
